exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.img {\n  margin-top: 10px;\n}\n.gift-img-box {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n}\n.gift-img-box img {\n  width: 40px;\n  height: 40px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/live/gift/dialog/Edit.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,aAAa;CACd","file":"Edit.vue","sourcesContent":["\n.img {\n  margin-top: 10px;\n}\n.gift-img-box {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n}\n.gift-img-box img {\n  width: 40px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f238cf8","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/live/gift/dialog/Edit.vue
// module id = DoxD
// module chunks = 0